import { Component } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent {
  currentUser: any;
  announcementModal: boolean = false;
  announcementForm: FormGroup;
  companies: any = [];
  announcements = [];
  loading: boolean = false;

  constructor(
    private dataService: DataserviceService,
    private message: NzMessageService,
    private app: AppComponent
    ) {

      this.announcementForm = new FormGroup({
        'company': new FormControl(null, [Validators.required]),
        'note': new FormControl(null, [Validators.required])
      });

    }

  hasPermissions(permission: string): boolean {
    return this.app.hasPermission(permission)
  }

  ngOnInit() {    
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    if(this.currentUser?.super_admin) {
      this.getCompanies();
    }else if(this.hasPermissions('view_distributor_companies')) {
      this.getDistributorCompanies()
    }else {
     this.companies.push({
      name: this.currentUser?.active_company_name,
      id: this.currentUser?.company_id
     })
    }
    this.loading = true;
    this.getAnnouncements();
  }

  showAddModal() {
    this.announcementForm.reset();
    this.announcementModal = true;
  }

  getAnnouncements() {
    this.dataService.getData('announcements/all')
      .subscribe({
        next: (res: any) => {
          this.announcements = res;
          this.loading = false;
        }
      })
  }

  getCompanies() {
    this.dataService.getData(`company`)
    .subscribe({
      next: (res: any) => {
        this.companies = res.data;
      },
      error: (err: any) => {
      }
    })
  }

    getDistributorCompanies() {
    this.dataService.getData(`company/companies-by-distributor/${this.currentUser?.distributor_id}`)
      .subscribe({
        next: (res: any) => {
          this.companies = res.data
        },
        error: (err: any) => {
          alert('Failed to load companies!')
        }
      })
  }

  addAnnoucement() {
    if(this.announcementForm.valid) {
      this.loading = true;
      this.dataService.postData(this.announcementForm.value, 'announcements/add')
        .subscribe({
          next: (res: any) => {
            this.announcementForm.reset();
            this.announcementModal = false;
            this.getAnnouncements();
            this.createMessage('success', 'Announcement added!')
          },
          error: (res: any) => {
            this.createMessage('error', 'Failed add announcement!')
          }
        })
    }else {
      this.createMessage('warning', 'Please fill out form correctly!')
    }
  }

  delete(a: any) {
    this.loading = true;
    this.dataService.postData(a, 'announcements/delete')
    .subscribe({
      next: (res: any) => {
        this.getAnnouncements();
        this.createMessage('success', 'Announcement deleted!')
      },
      error: (res: any) => {
        this.createMessage('error', 'Failed delete announcement!')
      }
    })
  }

  createMessage(type: string, message: string): void {
    this.message.create(type, message);
  }

}
